// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-icon[data-v-47bea0be] {\n  margin-left: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
